interface ReferidoNavigatorProps {
  currentIndex: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
  currentName?: string;
}

export function ReferidoNavigator({
  currentIndex,
  total,
  onPrev,
  onNext,
  currentName,
}: ReferidoNavigatorProps) {
  const isFirst = currentIndex === 0;
  const isLast = currentIndex === total - 1;

  return (
    <div className="flex items-center justify-between bg-white rounded-xl border border-gray-200 px-4 py-3">
      <button
        type="button"
        onClick={onPrev}
        disabled={isFirst}
        className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors ${
          isFirst
            ? 'text-gray-300 cursor-not-allowed'
            : 'text-primary-600 hover:bg-primary-50 active:bg-primary-100'
        }`}
        aria-label="Anterior"
      >
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      <div className="text-center">
        {currentName && (
          <p className="text-sm font-semibold text-gray-900">{currentName}</p>
        )}
        <p className="text-xs text-gray-500">
          {currentIndex + 1} de {total}
        </p>
      </div>

      <button
        type="button"
        onClick={onNext}
        disabled={isLast}
        className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors ${
          isLast
            ? 'text-gray-300 cursor-not-allowed'
            : 'text-primary-600 hover:bg-primary-50 active:bg-primary-100'
        }`}
        aria-label="Siguiente"
      >
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
}
